import cx from 'classnames'
import PropTypes from 'prop-types'
import React, { useEffect, useRef } from 'react'
import { gsap } from 'gsap'

import staggerAnimation from '../../utils/staggerAnimation'
import StartNav from '../../components/StartNav'
import AccessibleHiddenText from '../../components/AccessibleHiddenText'
import RichText from '../../components/RichText'
import { Icon } from '../../components'
import { iconsKeys } from '../../components/Icon/Icon.assets'
import withMemo from '../../decorators/withMemo'

import useStyles from './styles'


const GamePageTemplate = (props) => {
  const classes = useStyles(props)
  const { className, title, text, startNavProps } = props

  // animations
  const $animatedWrapper = useRef()

  useEffect(() => {
    const timeline = gsap.timeline()

    if ($animatedWrapper.current && text) {
      const animatedChildren = Array.from($animatedWrapper.current.children).filter((child) => !child.classList.contains('is-notstaggered'))

      staggerAnimation(0, animatedChildren, timeline, 0.5, '+=0.2', 0.5)
      timeline.play()
    }
    // cleanup
    return () => {
      timeline.clear()
    }
  }, [text])

  return (
    <div
      className={cx(className, classes.container)}
      ref={$animatedWrapper}
    >
      <div className={classes.logo}>
        <AccessibleHiddenText text={title} />
        <Icon
          icon={iconsKeys.LogoGame}
          className={classes.logoGame}
          aria-hidden="true"
        />
      </div>
      {text && (
        <RichText
          className={classes.text}
          json={text}
        />
      )}
      {startNavProps && (
        <StartNav
          className={classes.nav}
          {...startNavProps}
        />
      )}
    </div>
  )
}

export const GamePageTemplatePropTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  title: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  text: PropTypes.object,
  startNavProps: PropTypes.shape(),
}

GamePageTemplate.propTypes = GamePageTemplatePropTypes

GamePageTemplate.defaultProps = {
  className: null,
  children: null,
  title: '',
  text: null,
  startNavProps: null,
}

export default withMemo()(GamePageTemplate)
